import {
  EQUIPMENT_HOLDING_PROFILE_CREATE_TYPES,
  EQUIPMENT_HOLDING_PROFILE_FETCH_TYPES,
  EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES,
  EQUIPMENT_HOLDING_PROFILE_UPDATE_TYPES,
} from '../action-types/equipment-holding-profile';
import { axiosAction } from '../../utils/axiosAction';
import { constructSearchObj } from '../../utils/utils';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_HOLDING_PROFILES}`;

export const getEntities = params => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}${constructSearchObj(params)}`,
    EQUIPMENT_HOLDING_PROFILE_FETCH_TYPES,
    dispatch,
  );
};
export const createEntity = options => async dispatch => {
  return axiosAction.post(
    ENDPOINT,
    EQUIPMENT_HOLDING_PROFILE_CREATE_TYPES,
    dispatch,
    options,
  );
};
export const updateEntity = (options, id) => async dispatch => {
  return axiosAction.patch(
    `${ENDPOINT}/${id}`,
    EQUIPMENT_HOLDING_PROFILE_UPDATE_TYPES,
    dispatch,
    options,
  );
};
export const removeEntity = options => async dispatch => {
  return axiosAction.delete(
    `${ENDPOINT}/${options.id}`,
    EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES,
    dispatch,
  );
};
